import React from 'react';

const Section = ({ children, className = '', id = '', background = 'default' }) => {
  const bgClasses = {
    default: 'bg-white',
    alt: 'bg-slate-50',
    gradient: 'bg-gradient-to-b from-white to-slate-50',
  };

  return (
    <section 
      id={id}
      className={`
        py-[35px] md:py-16 lg:py-20
        ${bgClasses[background] || bgClasses.default}
        ${className}
      `}
      data-testid={id ? `${id}-section` : undefined}
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {children}
      </div>
    </section>
  );
};

export default Section;
